import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FreightDestinationPort } from '@core/proposals/freight-options';
import { SearchableSelectOption } from '../searchable-select/searchable-select.component';

/** Destination port autocomplete (with "Todos" and freight counts), freight text search and the "more freights" hint of the proposal freight dialogs. */
@Component({
  selector: 'app-freight-destination-filter',
  templateUrl: './freight-destination-filter.component.html',
  styleUrls: ['./freight-destination-filter.component.scss'],
})
export class FreightDestinationFilterComponent {
  @Input()
  set options(options: FreightDestinationPort[]) {
    this._options = options ?? [];
    // Built once per change: a new array on every change detection would reset what the user is typing.
    this.selectOptions = this._options
      .filter((o) => o.portId != null)
      .map((o) => ({ id: o.portId as number, name: o.name ?? '', count: o.freightCount }));
  }
  get options(): FreightDestinationPort[] {
    return this._options;
  }
  private _options: FreightDestinationPort[] = [];
  selectOptions: SearchableSelectOption[] = [];
  /** Selected destination port; null = "Todos". */
  @Input() value: number | null = null;
  /** The last freight query filled the take. */
  @Input() moreFreights = false;
  @Output() valueChange = new EventEmitter<number | null>();
  /** Free text typed in the freight search box (the dialog debounces it). */
  @Output() searchChange = new EventEmitter<string>();
}
